import React from 'react';

import { Link } from 'react-router-dom';

import Text from '../Text';
import './Footer.scss';

export default function FooterView({ hide }) {
  return !hide && (
  <footer className="siteFooter">
    <div className="siteFooterContent">
      <div className="copyrightWrapper">
        &copy;
        {' '}
        <span className="copyrightYear">
          {new Date().getFullYear()}
        </span>
        {' '}
        Trust Science Inc.
      </div>
      <Link to="/terms" aria-label="Terms of Use">
        <Text value="Terms of Use" />
      </Link>
      <Link to="/privacy" aria-label="Privacy Policy">
        <Text value="Privacy Policy" />
      </Link>
    </div>
  </footer>
  );
}
